module.exports = __webpack_public_path__ + "img/cszq_partners_3.47f06082.jpg";